const ATTRIBUTION_EXPIRY_KEY = "BT_AM_ATTRIBUTION_EXPIRY";

export const getAttributionExpiry = () => {
  // if window.__bt_intrnl.recoveryUserAttr defined it means that
  // bt_tag or bt_am already tried to restore server side user attribution in current page view,
  // so the attribution expiry value could be getting from the window object;
  if (window.__bt_intrnl.recoveryUserAttr) {
    return window.__bt_intrnl.recoveryUserAttr.attributionExpiry;
  }
  const attributionExpiryStr = localStorage.getItem(ATTRIBUTION_EXPIRY_KEY);
  return attributionExpiryStr ? Number(attributionExpiryStr) : undefined;
};

export const setAttributionExpiry = (expiry: number) =>
  localStorage.setItem(ATTRIBUTION_EXPIRY_KEY, expiry.toString());

export const hasAttributionExpirySet = () =>
  localStorage.getItem(ATTRIBUTION_EXPIRY_KEY) !== null;

export const deleteAttributionExpiry = () =>
  localStorage.removeItem(ATTRIBUTION_EXPIRY_KEY);
